/* @ngInject */
const ownerLabel = (utils) => {
  const self = {}

  self.class = 'Propriétaire'
  self.title = 'Propriétaires'

  self.fields = {
    id: {
      text: 'Id',
    },
    selectId: {
      text: 'Sélectionner l\'id du propriétaire',
    },
    society: {
      text: 'Société',
      messages: {
        exists: 'Ce nom de société existe déjà',
        invalid: 'Le nom de société est invalide',
      },
    },
    address: {
      text: 'Adresse',
    },
    cp: {
      text: 'Code postal',
    },
    city: {
      text: 'Ville',
    },
    country: {
      text: 'Pays',
    },
    contactCount: {
      text: 'Contacts',
    },
  }

  self.statements = {
    new: 'Nouveau propriétaire',
    empty: 'Aucun propriétaire',
    list: 'Liste des propriétaires',
    edit: (_society) => {
      return 'Modifier le propriétaire ' + _society
    },
  }

  self.ask = {
    delete: 'Êtes-vous sûr de vouloir supprimer ce propriétaire ?\nTous les contacts qui lui sont associés seront supprimés.',
  }

  self.log = {
    save: {
      success: 'Le propriétaire a bien été créé.',
      alreadyExists: 'Le propriétaire existe déjà.',
      failure: 'Une erreur est survenue lors de la création du propriétaire.',
    },
    update: {
      success: 'Le propriétaire a bien été modifié.',
      failure: 'Une erreur est survenue lors de la modification du propriétaire.',
    },
    delete: {
      success: 'Le propriétaire a bien été supprimé.',
      failure: 'Une erreur a interrompu la suppression du propriétaire.',
    },
    count: {
      failure: 'Les wagons ont bien été comptés.',
      failure: 'Impossible de compter le nombre de wagon.',
    },
    search: {
      success: (_length = 0) => {
        if (_length === 0) {
          return 'Aucun propriétaire ne correspond à la recherche.'
        } else if (_length === 1) {
          return '1 propriétaire a été trouvé.'
        } else if (_length > 1) {
          return _length + ' propriétaires ont été trouvés.'
        }
        return 'Propriétaire recherché.'
      },
      failure: 'Une erreur est survenue lors de la recherche des propriétaires',
      noResult: 'Aucun propriétaire ne correspond à cette recherche',
    },
  }

  return self
}

export default ownerLabel



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/owners/owner/resources/labels.resource.js